import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateCourseProgress } from '../../../../Utilities/api';
export const useUpdateCourseProgress = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ courseUuid, lectureUuid, completionToken }) => updateCourseProgress(courseUuid, lectureUuid, completionToken),
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['courseProgress', variables.courseUuid] });
            queryClient.invalidateQueries({ queryKey: ['lectureWatchtime', variables.courseUuid, variables.lectureUuid] });
            return data;
        },
    });
};
